import { useMutation, useQuery } from 'react-query';
import queryGetSimCards from './queries/getSimCards';
import queryGetSimGroups from './queries/getSimGroups';
import queryGetSimCard from './queries/getSimCard';
import queryGetSimOffersToUpdate from './queries/getSimOffersToUpdate';
import queryGetSimProviders from './queries/getSimProviders';
import queryGetCity from './queries/getCity';
import queryGetAddress from './queries/getAddress';
import queryGetOffersForSim from './queries/getSimOffers';
import mutationUpdateLabel from './mutations/updateLabel';
import mutationSuspendSimCard from './mutations/suspendSimCard';
import mutationActivateSimCard from './mutations/activateSimCard';
import mutationTerminateSimCard from './mutations/terminateSimCard';
import mutationReplaceSimCard from './mutations/replaceSimCard';
import mutationUpdateSimPlan from './mutations/updateSimPlan';
import mutationMultiActivateSimCards from './mutations/multiActivateSimCards';
import mutationAssociateSimCard from './mutations/associateSimCard';
import mutationAddSimCards from './mutations/addSimCards';
import queryGetSimGroupDetails from './queries/getSimGroupDetails';
import mutationAddSimCardsFromOrderId from './mutations/addSimCardsFromOrderId';
import mutationOrderSimCard from './mutations/orderSimCard';
import mutationAssignSimCards from './mutations/assignSimCards';
import mutationReassignAndUnassignSimCards from './mutations/reassignAndUnassignSimCards';
import queryGetSimPayviewOffers from './queries/getSimPayviewOffers';
import mutationMultiActivatePayviewSimCards from './mutations/multiActivatePayviewSimCards';
import mutationReactivateSimCard from './mutations/reactivateSimCard';

const actionsSims = {
    // Sim Cards
    // Getters
    getSimCards: (query, enabled = true) => useQuery(queryGetSimCards(query, enabled)),
    getSimCard: (simCardId, enabled = true) => useQuery(queryGetSimCard(simCardId, enabled)),
    getSimOffersToUpdate: (simCardId, enabled = true) => useQuery(queryGetSimOffersToUpdate(simCardId, enabled)),
    getSimProviders: (enabled = true) => useQuery(queryGetSimProviders(enabled)),
    getSimPayviewOffers: (provider, enabled = true) => useQuery(queryGetSimPayviewOffers(provider, enabled)),
    getOffersForSim: (enabled = true) => useQuery(queryGetOffersForSim(enabled)),


    // Mutations
    // SimCard add
    addSimCards: (onSuccess, onError) => useMutation(mutationAddSimCards(onSuccess, onError)),
    addSimCardsFromOrderId: (onSuccess, onError) => useMutation(mutationAddSimCardsFromOrderId(onSuccess, onError)),
    // SimCard associate
    associateSimCard: (onSuccess, onError) => useMutation(mutationAssociateSimCard(onSuccess, onError)),
    // SimCard status
    activateSimCard: (onSuccess, onError) => useMutation(mutationActivateSimCard(onSuccess, onError)),
    reactivateSimCard: (onSuccess, onError) => useMutation(mutationReactivateSimCard(onSuccess, onError)),
    suspendSimCard: (onSuccess, onError) => useMutation(mutationSuspendSimCard(onSuccess, onError)),
    terminateSimCard: (onSuccess, onError) => useMutation(mutationTerminateSimCard(onSuccess, onError)),
    replaceSimCard: (onSuccess, onError) => useMutation(mutationReplaceSimCard(onSuccess, onError)),
    // SimCard update label
    updateLabel: (onSuccess, onError) => useMutation(mutationUpdateLabel(onSuccess, onError)),
    // SimCard update plan
    updateSimPlan: (onSuccess, onError) => useMutation(mutationUpdateSimPlan(onSuccess, onError)),
    // Order sims
    orderSimCard: (onSuccess, onError) => useMutation(mutationOrderSimCard(onSuccess, onError)),
    // Sim card assign
    assignSimCards: (onSuccess, onError) => useMutation(mutationAssignSimCards(onSuccess, onError)),
    reassignAndUnassignSimCards: (onSuccess, onError) => useMutation(mutationReassignAndUnassignSimCards(onSuccess, onError)),
    // Sim card multi activation
    multiActivateSimCards: (onSuccess, onError) => useMutation(mutationMultiActivateSimCards(onSuccess, onError)),
    multiActivatePayviewSimCards: (onSuccess, onError) => useMutation(mutationMultiActivatePayviewSimCards(onSuccess, onError)),


    // Sim Groups
    // Getters
    getSimGroups: (query, enabled = true) => useQuery(queryGetSimGroups(query, enabled)),
    getSimGroupDetails: (groupId, enabled = true) => useQuery(queryGetSimGroupDetails(groupId, enabled)),
    // Address
    getCity: (postCode, enabled = true) => useQuery(queryGetCity(postCode, enabled)),
    getAddress: (city, cityCode, postCode, address, enabled = true) => useQuery(queryGetAddress(city, cityCode, postCode, address, enabled))

};

export default actionsSims;